import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { Modal }            from 'react-bootstrap';
import {SetError}           from '../../../actions/authenticActions';
import { GetBadge,
         serActionBadge }   from '../../../actions/talentosAction';

import bad_o_0  from '../../../img/badges/obestinado_o.png';
import bad_p_0  from '../../../img/badges/obestinado_p.png';
import bad_b_0  from '../../../img/badges/obestinado_b.png';
import bad_d_0  from '../../../img/badges/obestinado_d.png';

import bad_o_1  from '../../../img/badges/veterano_o.png';
import bad_p_1  from '../../../img/badges/veterano_p.png';
import bad_b_1  from '../../../img/badges/veterano_b.png';
import bad_d_1  from '../../../img/badges/veterano_d.png';

import bad_o_2  from '../../../img/badges/exterminador_o.png';
import bad_p_2  from '../../../img/badges/exterminador_p.png';
import bad_b_2  from '../../../img/badges/exterminador_b.png';
import bad_d_2  from '../../../img/badges/exterminador_d.png';

import bad_o_3  from '../../../img/badges/perito_o.png';
import bad_p_3  from '../../../img/badges/perito_p.png';
import bad_b_3  from '../../../img/badges/perito_b.png';
import bad_d_3  from '../../../img/badges/perito_d.png';

import bad_o_4  from '../../../img/badges/decodificador_o.png';
import bad_p_4  from '../../../img/badges/decodificador_p.png';
import bad_b_4  from '../../../img/badges/decodificador_b.png';
import bad_d_4  from '../../../img/badges/decodificador_d.png';

import bad_o_5 from '../../../img/badges/predestinado_o.png';
import bad_p_5 from '../../../img/badges/predestinado_p.png';
import bad_b_5 from '../../../img/badges/predestinado_b.png';
import bad_d_5 from '../../../img/badges/predestinado_d.png';

import bad_o_6  from '../../../img/badges/recordista_o.png';
import bad_p_6  from '../../../img/badges/recordista_b.png';
import bad_b_6  from '../../../img/badges/recordista_p.png';
import bad_d_6  from '../../../img/badges/recordista_d.png';

import bad_o_7  from '../../../img/badges/explorador_o.png';
import bad_p_7  from '../../../img/badges/explorador_p.png';
import bad_b_7  from '../../../img/badges/explorador_b.png';
import bad_d_7  from '../../../img/badges/explorador_d.png';

import bad_o_8  from '../../../img/badges/desbravador_o.png';
import bad_p_8  from '../../../img/badges/desbravador_p.png';
import bad_b_8  from '../../../img/badges/desbravador_b.png';
import bad_d_8  from '../../../img/badges/desbravador_d.png';


class feeds_badg extends Component {
    constructor(props){
        super(props);
        this.state = {
            showModal:false,
            load:false,
            load2:false,
            use_id: this.props.session.id,
            cur_id: this.props.session.curso,
            badge:[],
            badgeSelect:[],
            badg0:{img:bad_d_0,img_1:bad_d_0,img_2:bad_b_0,img_3:bad_p_0,img_4:bad_o_0,nome:null,titulo:null,nivel:0,action:false},
            badg1:{img:bad_d_1,img_1:bad_d_1,img_2:bad_b_1,img_3:bad_p_1,img_4:bad_o_1,nome:null,titulo:null,nivel:0,action:false},
            badg2:{img:bad_d_2,img_1:bad_d_2,img_2:bad_b_2,img_3:bad_p_2,img_4:bad_o_2,nome:null,titulo:null,nivel:0,action:false},
            badg3:{img:bad_d_3,img_1:bad_d_3,img_2:bad_b_3,img_3:bad_p_3,img_4:bad_o_3,nome:null,titulo:null,nivel:0,action:false},
            badg4:{img:bad_d_4,img_1:bad_d_4,img_2:bad_b_4,img_3:bad_p_4,img_4:bad_o_4,nome:null,titulo:null,nivel:0,action:false},
            badg5:{img:bad_d_5,img_1:bad_d_5,img_2:bad_b_5,img_3:bad_p_5,img_4:bad_o_5,nome:null,titulo:null,nivel:0,action:false},
            badg6:{img:bad_d_6,img_1:bad_d_6,img_2:bad_b_6,img_3:bad_p_6,img_4:bad_o_6,nome:null,titulo:null,nivel:0,action:false},
            badg7:{img:bad_d_7,img_1:bad_d_7,img_2:bad_b_7,img_3:bad_p_7,img_4:bad_o_7,nome:null,titulo:null,nivel:0,action:false},
            badg8:{img:bad_d_8,img_1:bad_d_8,img_2:bad_b_8,img_3:bad_p_8,img_4:bad_o_8,nome:null,titulo:null,nivel:0,action:false},
        }
    }

    componentWillMount() {
        
        this.badge();

    }    

    badge(){

        this.props.GetBadge(this.state.use_id,this.state.cur_id).then((response)=>{
            this.setState({load:true});
            this.renderBadge();
        }).catch((error) => {
         //   this.props.SetError(500);
         });
    }

    renderBadge(){

        const badge = this.props.allBadge.badges;
        badge.map((elem,i)=>{
           
            var obj = {}
            switch (elem.nivel_usuario) {
                case 0:
                  obj.img = this.state[`badg${i}`][`img_1`];
                break;

                case 1:
                  obj.img = this.state[`badg${i}`][`img_2`];  
                break;

                case 2:
                obj.img = this.state[`badg${i}`][`img_3`];   
                break;
            
                case 3:
                obj.img = this.state[`badg${i}`][`img_4`];
              
                break;

            }

            this.setState({[`badg${i}`]:{
                                         bad_id:elem.bad_id,
                                         img:obj.img,
                                         nome:null,
                                         titulo:null,
                                         nivel:null,
                                         img_1:this.state[`badg${i}`][`img_1`],
                                         img_2:this.state[`badg${i}`][`img_2`],
                                         img_3:this.state[`badg${i}`][`img_3`],
                                         img_4:this.state[`badg${i}`][`img_4`],
                                        },load2:true
                          });
        });

    }

    open(val){
      this.setState({showModal:true,badgeSelect:this.props.allBadge.badges[val],badge:this.state[`badg${val}`]})
    }

    close(){
     this.setState({showModal:false})
    }

    setActionBadge(id){
        this.props.serActionBadge(id,this.props.session.turma).then((response)=>{
            this.badge();
            this.close();
        }).catch((error) => {
          this.props.SetError(500);
        });
    }

    render() {
      
        var actionPrincipal    = "";
        var actionPrincipalimg = false;
        var imgPrincipal = false;
        var tituloPrincipal = "";
        var subTituloPrincipal = "";
        var action = {}
        if (this.state.load2) {
        if(this.props.allBadgePrincipal){
            var actionPrincipal    = "feed-hex-active-100";   
            var actionPrincipalimg = true;
            var dados = this.props.allBadge.badges;
            dados.map((elem,i) => {
               
                if(this.state[`badg${i}`].bad_id === this.props.allBadgePrincipal.bad_id){
                      action.imgPrincipal = this.state[`badg${i}`].img;
                      action.tituloPrincipal = this.props.allBadgePrincipal.bad_titulo;
                      action.subTituloPrincipal = this.props.allBadgePrincipal.bad_nome;                      
                }
            });
        
            var imgPrincipal = action.imgPrincipal;
            var tituloPrincipal = action.tituloPrincipal;
            var subTituloPrincipal = action.subTituloPrincipal;
           
        }
    }

        const mo = {'marginLeft': '-2em','height':'430px'}
        return (
           <div className="feed-container feed-container-left">
                        <div className="feed-grid feed-grid-center feed-grid-offset-half">
                            <div className="feed-column">
                                <div className="feed-hex feed-hex-empty"></div>
                                <div className="feed-hex feed-hex-empty"></div>
                                <div className="feed-hex feed-hex-empty">
                                    <div className="feed-hex-body"></div>
                                    <div className="feed-hex-label feed-hex-label-up-3-left">
                                        <a href={void(0)} onClick={this.open.bind(this,0)} className="feed-hex-badge badge0">
                                            <img src={this.state.badg0.img} width="50"></img>
                                        </a>

                                    </div>
                                    <div className="feed-hex-label feed-hex-label-up-2-left">
                                        <a href={void(0)} onClick={this.open.bind(this,1)} className="feed-hex-badge badge1">
                                          <img src={this.state.badg1.img} width="50"></img>
                                        </a>

                                    </div>
                                     <div className="feed-hex-label feed-hex-label-down-3-left">
                                        <a href={void(0)} onClick={this.open.bind(this,2)}  className="feed-hex-badge badge2">
                                          <img src={this.state.badg2.img} width="50"></img>
                                        </a>

                                    </div>
                                </div>
                                <div className="feed-hex feed-hex-empty">
                                    <div className="feed-hex-label feed-hex-label-up-2-left">
                                        <a href={void(0)} onClick={this.open.bind(this,3)} className="feed-hex-badge badge3">
                                          <img src={this.state.badg3.img} width="50"></img>
                                        </a>

                                    </div>
                                </div>
                            </div>
                            <div className="feed-column">
                                <div className="feed-hex feed-hex-border-no-right"></div>
                                <div className={`feed-hex feed-hex ${actionPrincipal}`}>
                                    {actionPrincipalimg?
                                        <a href={void(0)} className="feed-hex-badge badge4">
                                           <img src={imgPrincipal} width="100"></img>
                                        </a>:""                                    
                                    }
                                </div>
                                <div className="feed-hex feed-hex-empty"></div>
                                <div className="feed-hex feed-hex-border-opacity-40">
                                    <div className="feed-hex-label feed-hex-label-up-3-right">
                                        <a href={void(0)} onClick={this.open.bind(this,5)} className="feed-hex-badge badge5">
                                           <img src={this.state.badg5.img} width="50"></img>
                                        </a>

                                    </div>
                                    <div className="feed-hex-label feed-hex-label-down-3-left">
                                        <a href={void(0)} onClick={this.open.bind(this,6)} className="feed-hex-badge badge6">
                                          <img src={this.state.badg6.img} width="50"></img>
                                        </a>
                                    </div>                                    
                                </div>
                            </div>
                            <div className="feed-column feed-column-single">
                                <div className="feed-hex feed-hex-title feed-hex-long feed-hex-empty">
                                {actionPrincipalimg?<div className="feed-hex-header">{tituloPrincipal}</div>:""}
                                {actionPrincipalimg?<div className="feed-hex-footer">{subTituloPrincipal}</div>:"" }
                                </div>
                                <div className="feed-hex"></div>
                                <div className="feed-hex">
                                    <div className="feed-hex-label feed-hex-label-down-3-left">
                                        <a href={void(0)} onClick={this.open.bind(this,4)} className="feed-hex-badge badge4">
                                        <img src={this.state.badg4.img} width="50"></img>
                                        </a>

                                    </div>
                                </div>
                                <div className="feed-hex feed-hex-empty"></div>
                                <div className="feed-hex feed-hex-border-opacity-40"></div>
                            </div>
                            <div className="feed-column">
                                <div className="feed-hex feed-hex-empty"></div>
                                <div className="feed-hex feed-hex-empty"></div>
                                <div className="feed-hex feed-hex-border-opacity-40">
                                    <div className="feed-hex-label feed-hex-label-down-3-left">
                                        <a href={void(0)} onClick={this.open.bind(this,7)} className="feed-hex-badge badge7">
                                           <img src={this.state.badg7.img} width="50"></img>
                                        </a>

                                    </div>
                                    <div className="feed-hex-label feed-hex-label-up-2-right">
                                        <a href={void(0)} onClick={this.open.bind(this,8)} className="feed-hex-badge badge8">
                                          <img src={this.state.badg8.img} width="50"></img>
                                        </a>

                                    </div>
                                </div>
                                <div className="feed-hex feed-hex-empty"></div>
                                <div className="feed-hex feed-hex-active feed-hex-active-20"></div>
                            </div>
                            <div className="feed-column">

                                <div className="feed-hex feed-hex-empty"></div>
                                <div className="feed-hex feed-hex-empty"></div>
                                <div className="feed-hex feed-hex-empty"></div>
                                <div className="feed-hex feed-hex-empty"></div>
                                <div className="feed-hex"></div>
                            </div>
                            <div className="feed-column">

                                <div className="feed-hex feed-hex-empty"></div>
                                <div className="feed-hex feed-hex-empty">
                                </div>
                                <div className="feed-hex">

                                </div>
                                <div className="feed-hex feed-hex-border-opacity-40">

                                </div>
                                <div className="feed-hex feed-hex-empty">

                                </div>
                            </div>
                        </div>
                        <Modal show={this.state.showModal}  bsSize="lg">
                        <div
                        className="box box-small box-auto box-fixed unbluring"
                        data-reference=".feed-container-right"
                        style={mo}>
                        <div className="box-header">
                            <div className="box-header-decoration"></div>
                            <div className="box-header-info">
                                <div className="box-header-info-tools">
                                  <a href={void(0)} onClick={this.close.bind(this)} className="simple-action">&times;</a>
                                </div>
                            </div>
                        </div>
                        <div className="box-body">
                            <div className="feed-box">
                                <div className="feed-box-header">
                                    <div className="feed-box-header-badge">
                                        <div className="feed-hex-badge">
                                            <img
                                                src={this.state.badge.img}
                                                width="70"></img>
                                        </div>

                                    </div>
                                    <div className="feed-box-header-title">
                                        {this.state.badgeSelect.bad_titulo}
                                        <hr className="primary-border"/>
                                     
                                    </div>
                                </div>
                                <div className="box-row">
                                {this.state.badgeSelect.bad_nivel_1?    
                                <a
                                        href="javascript:void(0)"
                                        className="box-action box-column box-column-borderless box-background-active">
                                        <div className="box-title-alternative">
                                            <div className="feed-hex-badge">
                                            <img
                                                src={this.state.badge.img_2}
                                                width="50"></img>
                                            </div>
                                            Bronze
                                        </div>
                                        <div className="box-text no-tip">
                                        {this.state.badgeSelect.bad_nivel_1}
                                        </div>
                                    </a>:""}
                                    {this.state.badgeSelect.bad_nivel_2?                                     
                                    <a
                                        href="javascript:void(0)"
                                        className="box-action box-column box-column-borderless box-background-active">
                                        <div className="box-title-alternative">
                                            <div className="feed-hex-badge">
                                            <img
                                                src={this.state.badge.img_3}
                                                width="50"></img>
                                            </div>

                                            Prata
                                        </div>
                                        <div className="box-text no-tip">
                                        {this.state.badgeSelect.bad_nivel_2}
                                        </div>
                                    </a>
                                    :""}
                                    {this.state.badgeSelect.bad_nivel_3?    
                                    <a
                                        href="javascript:void(0)"
                                        className="box-action box-column box-column-borderless box-background-active">
                                        <div className="box-title-alternative">
                                            <div className="feed-hex-badge">
                                            <img
                                                src={this.state.badge.img_4}
                                                width="50"></img>
                                            </div>

                                            Ouro
                                        </div>
                                        <div className="box-text no-tip">
                                        {this.state.badgeSelect.bad_nivel_3}
                                        </div>
                                    </a>
                                    :""}    
                                </div>
                                <div className="feed-box-footer">
                                {this.state.badgeSelect.nivel_usuario == 3 ? <div className="feed-box-footer-text">Para trocar sua nomenclatura, clique em escolher ></div>: "" } 
                                {this.state.badgeSelect.nivel_usuario == 3 ? <a href={void(0)} onClick={this.setActionBadge.bind(this,this.state.badgeSelect.bad_id)} className="action">Escolher</a> : "" } 
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                    </div>
        );
    }
}

function  mapStateToProps(state){
    return {
             session     : state.auth.session,
             actionModal : state.scopoReducer.actionModal,
             allBadge    : state.talentosReducer.allBadge,
             allBadgePrincipal : state.talentosReducer.allBadgePrincipal,
    }
}
export default connect(mapStateToProps,{GetBadge,serActionBadge,SetError})(feeds_badg);




// WEBPACK FOOTER //
// ./src/components/aluno/home/feeds_badg.js